import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const EquipmentTypeList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                sessionStorage.setItem('editingEquipmentType', JSON.stringify(row))
                sessionStorage.setItem('operationType', operation)  
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    return (
        <M_Table
            entityName={'EquipmentType'}
            api='secondary'
            showTitle={true}
            title={'Equipment Types'} 
            roleName={'usersGroups'}
            rolePermissions={roles}
            replaceFunctions={new Map([
                ['Create', (row) => newRoute('containerControl/equipmentTypeCrud', 'Create', t('Add')+' '+t('EquipmentType'), row)],
                ['Edit', (row) => newRoute('containerControl/equipmentTypeCrud', 'Edit', t('Edit')+' '+t('EquipmentType'), row)],
                ['Copy', (row) => newRoute('containerControl/equipmentTypeCrud', 'Copy', t('Copy')+' '+t('EquipmentType'), row)]
            ])}
        />
    )
}